import React, {useReducer} from "react";

import {OptionalContent} from "../../components/OptionalContent";
import TrixEditor from "./TrixEditor";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";


const EmailEditor = (props) => {
    const {emailEditor, boxProps = {}} = props;
    const [editEnabled, toggleEditEnabled] = useReducer(state => !state, false);

    return <>
        {
            emailEditor.isLoadingTemplates ?
                <Box textAlign="center">
                    <CircularProgress color="primary"/>
                </Box>
                :
                <OptionalContent hasContent={emailEditor.selectedTemplateId !== null}
                                 noContentMessage="Nessun modello email presente"
                                 showIcon>
                    <Stack>
                        <Stack direction="row" justifyContent="space-between">
                            <Typography variant="caption" color="text.primary">
                                {
                                    editEnabled ?
                                        "Puoi modificare tutti i contenuti nei box evidenziati"
                                        :
                                        "Modifiche non abilitate, premere sull'interruttore per abilitare la modilità di modifica"
                                }
                            </Typography>
                            <Switch size="small" checked={editEnabled} onChange={toggleEditEnabled}/>
                        </Stack>

                        <Box boxShadow={2} sx={{minHeight: "200px", ...boxProps}}>
                            {
                                emailEditor.isLoading && <Box textAlign="center" sx={{pt: 5, pb: 5}}>
                                    <CircularProgress color="primary"/>
                                </Box>
                            }
                            {
                                emailEditor.selectedTemplateId !== null && emailEditor.showIframe &&
                                <Collapse in={!emailEditor.isIframeLoading} timeout={500}>
                                    <TrixEditor iframeRef={emailEditor.iframeRef}
                                                iframeLoaded={!emailEditor.isIframeLoading}
                                                editEnabled={editEnabled}
                                                onTemplateUserVariableChange={emailEditor.updateTemplateUserVariable}>
                                        <iframe ref={emailEditor.iframeRef}
                                                title="template-viewer"
                                                scrolling="no"
                                                srcDoc={emailEditor.rendering}
                                                width={"100%"}
                                                frameBorder="0"
                                                onLoad={emailEditor.onTemplateLoaded}
                                        />
                                    </TrixEditor>
                                </Collapse>
                            }
                        </Box>
                    </Stack>
                </OptionalContent>
        }
    </>
}

export default EmailEditor;